import { ARLResponse } from '../../interceptor/base.api.response';
import arlApi from '../../interceptor/api';

type ConfigKeysResponse = {
	gmapsKey: string;
	ewayEncryptionKey: string;
};

let configKeysPromise: Promise<ConfigKeysResponse> | null = null;

export const getConfigKeys = async (): Promise<ConfigKeysResponse> => {
	if (!configKeysPromise) {
		configKeysPromise = arlApi
			.get<ARLResponse<ConfigKeysResponse>>('/api/config/key')
			.then(({ data }) => {
				if (!data.success || !data.data) {
					throw new Error(data.message || 'Unable to load config keys');
				}
				return data.data;
			})
			.catch((error) => {
				configKeysPromise = null;
				throw error;
			});
	}

	return configKeysPromise;
};
